import { Component, OnInit } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Nationality } from '../nationality';
import { WpTranslationItem } from '../wp-translation-item';
import { HttpService } from '../service/http.service';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-strip-wp-tags',
  templateUrl: './strip-wp-tags.component.html',
  styleUrls: ['./strip-wp-tags.component.css']
})
export class StripWpTagsComponent implements OnInit {

  inputText: string | undefined;
  outputText = "";
  inputTranslationText = "";
  translationModes = [
    { name: "noTranslation", value: 0, label: "No Translation" },
    { name: "frenchToDutch", value: 1, label: "French to Dutch" },
    { name: "frenchToEnglish", value: 2, label: "French to English" }
  ];
  translationMode = 0;

  translationItems: WpTranslationItem[] = [];
  translationItemForm: FormGroup | undefined;
  selectedItem: WpTranslationItem | undefined;
  translationItemsForm: FormArray | undefined;
  translationItemFormGroup!: FormGroup[];

  constructor(
    private messageService: MessageService,
    private httpService: HttpService,
    private builder: FormBuilder,
    private confirmationService: ConfirmationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.updateAll();
    this.translationItemForm = this.builder.group({
      french: "",
      dutch: "",
      english: ""
    });
  }

  updateAll() {
    this.httpService.getTranslations().subscribe(res => {
      this.translationItems = res;
      console.log(this.translationItems);
      this.initFormArray();
    });
  }

  initFormArray() {
    this.translationItemFormGroup = [];
    for (let item of this.translationItems) {
      let group = this.builder.group({
        french: item.french,
        dutch: item.dutch,
        english: item.english
      });
      this.translationItemFormGroup.push(group);
    }
  }

  updateTranslationItems() {
    this.httpService.getTranslations().subscribe(res => {
      this.translationItems = res;
    });
  }

  stripTags() {
    const regex = /(<!-- wp:paragraph -->([\s\S]*?)<!-- \/wp:paragraph -->)+/gm;
    try {
      const textWithoutLineBreak = this.inputText!.replace(/\n/gm, "");
      const newText = textWithoutLineBreak.replace(regex, "<!-- wp:paragraph --><!-- \/wp:paragraph -->");
      const regex2 = /(<!-- wp:list -->([\s\S]*?)<!-- \/wp:list -->)+/gm;
      this.inputText = newText.replace(regex2, "");

      this.addSuccess("🎊Success🎊", "Conversion successful");

      if (this.translationMode == 0) {
        return;
      }
      if (this.translationMode == 1) {
        this.translateFrToNl();
        return;
      }
      if (this.translationMode == 2) {
        this.translateFrToEn();
        return;
      }
    } catch (error: any) {
      this.addError("Error", error);
    }
  }

  addSuccess(summary: string, detail: string) {
    this.messageService.add({ severity: 'success', summary: summary, detail: detail });
  }

  addError(summary: string, detail: string) {
    this.messageService.add({ severity: 'error', summary: summary, detail: detail });
  }

  translateFrToNl() {
    try {
      for (let item of this.translationItems) {
        if (item.dutch != null || item.dutch != "") {
          this.inputText = this.inputText!.replace(new RegExp(item.french, "gm"), item.dutch);
        }
      };
      this.addSuccess("😍Success😍", "Translation successful");
    } catch (error: any) {
      this.addError("Error", error);
    }
  }

  translateFrToEn() {
    try {
      for (let item of this.translationItems) {
        if (item.english != null || item.english != "") {
          this.inputText = this.inputText!.replace(new RegExp(item.french, "gm"), item.english);
        }
      };
      this.addSuccess("😍Success😍", "Translation successful");
    } catch (error: any) {
      this.addError("Error", error);
    }
  }

  changeMode() {
    console.log(this.translationMode);
  }

  saveTranslations() {
    let payload = [];
    let sortOrder = 0;
    for (let item of this.translationItems) {
      payload.push(
        new WpTranslationItem(
          item.french, item.dutch, item.english, sortOrder
        )
      );
      sortOrder += 10;
    }
    this.httpService.postTranslations(payload)
      .subscribe(() => {
        console.log("success");
      });
  }

  postNewLine() {
    let lastItem = this.translationItems.reduce((a, b) => {
      return a.sortOrder < b.sortOrder ? b : a
    });

    let item = new WpTranslationItem(
      this.translationItemForm!.value.french.trim(),
      this.translationItemForm!.value.dutch.trim(),
      this.translationItemForm!.value.english.trim(),
      lastItem.sortOrder + 10
    );
    let itemArray = [];
    itemArray.push(item);

    this.httpService.postTranslations(itemArray)
      .subscribe(() => {
        this.updateTranslationItems();
      });
  }

  selectItem(item: WpTranslationItem) {
    this.selectedItem = item;
    console.log(item);
    console.log(this.translationItems.indexOf(item));
  }

  orderBefore() {
    if (this.translationItems.indexOf(this.selectedItem!) == 0) {
      return;
    }
    let tempSortOrder = this.selectedItem!.sortOrder;
    let itemBefore = this.translationItems[this.translationItems.indexOf(this.selectedItem!) - 1];
    this.selectedItem!.sortOrder = itemBefore.sortOrder;
    itemBefore.sortOrder = tempSortOrder;
    let itemsToUpdate = [this.selectedItem!, itemBefore];
    this.httpService.updateTranslations(itemsToUpdate)
      .subscribe(() => {
        console.log("success");
        this.updateAll();
      });
  }

  orderAfter() {
    if (this.translationItems.indexOf(this.selectedItem!) + 1 == this.translationItems.length) {
      return;
    }
    let tempSortOrder = this.selectedItem!.sortOrder;
    let itemBefore = this.translationItems[this.translationItems.indexOf(this.selectedItem!) + 1];
    this.selectedItem!.sortOrder = itemBefore.sortOrder;
    itemBefore.sortOrder = tempSortOrder;
    let itemsToUpdate = [this.selectedItem!, itemBefore];
    this.httpService.updateTranslations(itemsToUpdate)
      .subscribe(() => {
        console.log("success");
        this.updateAll();
      });
  }

  update() {
    let item = this.selectedItem!;
    let selectedtranslationItemFormGroup = this.translationItemFormGroup![this.translationItems.indexOf(this.selectedItem!)];
    item.french = selectedtranslationItemFormGroup.value.french;
    item.dutch = selectedtranslationItemFormGroup.value.dutch;
    item.english = selectedtranslationItemFormGroup.value.english;

    this.httpService.updateTranslation(item).subscribe(() => {
      console.log("update successfull");
      this.updateAll();
    });
  }

  delete() {
    this.confirmationService.confirm({
      message: this.sanitizer.bypassSecurityTrustHtml("Are you sure that you want to delete this record? </br> French: " 
      + this.selectedItem!.french + "</br>" + "Dutch: " + this.selectedItem!.dutch + "</br>" + "English: " +this.selectedItem!.english) as string,
      accept: () => {
        this.httpService.deleteTranslation(this.selectedItem!.id!)
        .subscribe( () => {
          this.updateAll();
        });
      },
      reject: () => {
        return;
      },
      acceptLabel: "Yes, delete it",
      rejectLabel: "No, not sure"
    });

  }

}
